import { create } from 'zustand';

import {
  apiListGalleriesForProfile,
  type ProfileGalleryWorkspaceSection,
} from '../api/galleryFetch';

export type ReloadProfileGalleriesOptions = {
  canViewGalleries?: boolean;
  onError?: (message: string) => void;
};

type ProfileGalleriesState = {
  ownSections: ProfileGalleryWorkspaceSection[];
  sharedSections: ProfileGalleryWorkspaceSection[];
  isLoading: boolean;
  isLoaded: boolean;
  reloadGalleries: (options?: ReloadProfileGalleriesOptions) => Promise<void>;
  resetProfileGalleries: () => void;
};

const emptyState = {
  ownSections: [] as ProfileGalleryWorkspaceSection[],
  sharedSections: [] as ProfileGalleryWorkspaceSection[],
  isLoading: false,
  isLoaded: false,
};

export const useProfileGalleriesStore = create<ProfileGalleriesState>((set) => ({
  ...emptyState,

  reloadGalleries: async (options = {}) => {
    const { canViewGalleries = true, onError } = options;

    if (!canViewGalleries) {
      set({ ...emptyState, isLoaded: true });
      return;
    }

    set({ isLoading: true });
    try {
      const data = await apiListGalleriesForProfile();
      set({
        ownSections: data.own,
        sharedSections: data.shared,
        isLoading: false,
        isLoaded: true,
      });
    } catch (err: unknown) {
      const message = err instanceof Error ? err.message : 'Failed to load galleries';
      onError?.(message);
      set({
        ownSections: [],
        sharedSections: [],
        isLoading: false,
        isLoaded: true,
      });
    }
  },

  resetProfileGalleries: () => set(emptyState),
}));
